var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"border-2 text-black active:bg-blueGray-600 py-2 lg:py-3 px-2 rounded shadow hover:shadow-lg outline-none focus:outline-none ease-linear transition-all duration-150"},[_c('i',{staticClass:"fas fa-chair"}),_c('router-link',{attrs:{"to":{
      path: ("/store/" + _vm.storeId + "/catalog"),
      query: { position: _vm.name },
    }}},[_vm._v(" "+_vm._s(_vm.name)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }